export default __webpack_public_path__ + "static/media/orangeTheme-girl.4877b171.jpeg";